/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PreseasonTimeControllerService {
    /**
     * @param requestBody
     * @returns any Created
     * @throws ApiError
     */
    public static addTeamSchedules(
        requestBody: {
            seasonDefinitionId: number;
            teamId: number;
            schedules: Array<any>;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/preseason-times/team-schedules',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any Created
     * @throws ApiError
     */
    public static addYearRoundTerm(
        requestBody: any,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/preseason-times/year-round-term',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param preseasonTimeId
     * @returns any OK
     * @throws ApiError
     */
    public static getTeamSchedulesByPreseasonTimeId(
        preseasonTimeId: number,
    ): CancelablePromise<Array<any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/preseason-times/{preseasonTimeId}/team-schedules',
            path: {
                'preseasonTimeId': preseasonTimeId,
            },
        });
    }
}
